import { AlertCircle, CheckCircle2, Clock, TrendingUp } from 'lucide-react';
import type { ExposureHedgeStatus } from '../api/exposure';
import type { ExposureView } from './exposure-status';

export interface StatusMeta {
  pill: string;
  dot: string;
  pillLabel: string;
  openText: string;
  icon: typeof AlertCircle;
}

export const STATUS_META: Record<ExposureHedgeStatus, StatusMeta> = {
  Unhedged: {
    pill: 'border-rose-200 bg-rose-50 text-rose-900',
    dot: 'bg-rose-500',
    pillLabel: 'Open',
    openText: 'text-rose-700',
    icon: AlertCircle,
  },
  'Partially Hedged': {
    pill: 'border-amber-200 bg-amber-50 text-amber-900',
    dot: 'bg-amber-500',
    pillLabel: 'Partial',
    openText: 'text-amber-700',
    icon: Clock,
  },
  'Fully Hedged': {
    pill: 'border-emerald-200 bg-emerald-50 text-emerald-900',
    dot: 'bg-emerald-500',
    pillLabel: 'Covered',
    openText: 'text-emerald-700',
    icon: CheckCircle2,
  },
  'No Hedge Required': {
    pill: 'border-slate-200 bg-slate-50 text-slate-700',
    dot: 'bg-slate-400',
    pillLabel: 'N/A',
    openText: 'text-slate-600',
    icon: TrendingUp,
  },
};

export const VIEW_HEADER_COLOR: Record<ExposureView, string> = {
  'needs-action': 'text-rose-700',
  'in-progress': 'text-amber-700',
  covered: 'text-emerald-700',
  'no-action': 'text-muted-foreground',
};

// Inline-styled grid template used by both the column header row and each
// data row in the hedge book table. Centralised here so the two stay aligned.
export const GROUP_COLUMNS = '1.5rem minmax(11rem, 1.4fr) 3rem 1fr 7rem 7rem 7rem 8rem 8rem';

export function coverageBarColor(status: ExposureHedgeStatus): string {
  if (status === 'Fully Hedged') return 'bg-emerald-500';
  if (status === 'Partially Hedged') return 'bg-amber-500';
  return 'bg-muted-foreground/30';
}

export function coverageTextColor(status: ExposureHedgeStatus): string {
  if (status === 'Fully Hedged') return 'text-emerald-700';
  if (status === 'Partially Hedged') return 'text-amber-700';
  return 'text-muted-foreground';
}

export function formatMt(n: number): string {
  return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
